'use client'
import { clsx } from 'clsx'
import { AnimatePresence, domAnimation, LazyMotion, m as motion } from 'framer-motion'

import { FC, ReactNode, useState } from 'react'

import { IChildren, IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface IAnimationHeight extends IClassName, IChildren {
  slotBtn: (handleToggle: () => void, open: boolean) => ReactNode
  startHeight?: string
  isOpen?: boolean
  contentClass?: string
  paddingBottom?: number
}

// component
const AnimationHeightComponent: FC<Readonly<IAnimationHeight>> = ({
  children,
  className,
  slotBtn,
  startHeight,
  isOpen,
  contentClass,
  paddingBottom,
}) => {
  const [open, setOpen] = useState<boolean>(isOpen ?? false)

  const generateStyleHEight = (status: boolean) => (status ? 'auto' : (startHeight ?? 0))

  const handleToggle = () => {
    setOpen(!open)
  }

  // return
  return (
    <div className={clsx(className, 'relative overflow-hidden')}>
      <LazyMotion features={domAnimation}>
        <AnimatePresence>
          <motion.div
            style={{
              minHeight: startHeight ?? 0,
              paddingBottom: paddingBottom ?? 30,
            }}
            animate={{ height: generateStyleHEight(open) }}
            transition={{
              duration: 0.3,
              ease: 'linear',
            }}
            initial={{
              height: generateStyleHEight(open),
            }}
            className={contentClass}
          >
            {children}
          </motion.div>
        </AnimatePresence>
      </LazyMotion>
      {slotBtn(handleToggle, open)}
    </div>
  )
}

export default AnimationHeightComponent
